import React from 'react'
import { sizes, socialIconColors } from './const'
export interface PinterestProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon including the cirlce.
     * */
    color?: 'white' | 'black'
}

export const PinterestIcon = ({
    className = 'js_PinterestIcon',
    size = 'large',
    color = 'black',
}: PinterestProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 32 32"
        >
            <g fillRule="evenodd">
                <circle
                    className={`${socialIconColors[color][0]}`}
                    cx={16}
                    cy={16}
                    r={15.5}
                />
                <path
                    className={`${socialIconColors[color][1]}`}
                    d="M16.36 9.6c-3.785 0-5.693 2.713-5.693 4.976 0 1.37.518 2.588 1.63 3.042.183.075.346.003.4-.2.036-.138.123-.491.162-.638.053-.2.033-.27-.115-.444-.32-.378-.526-.868-.526-1.562 0-2.013 1.506-3.815 3.922-3.815 2.139 0 3.314 1.307 3.314 3.052 0 2.297-1.016 4.235-2.525 4.235-.833 0-1.457-.688-1.257-1.534.24-1.009.703-2.097.703-2.826 0-.652-.35-1.196-1.074-1.196-.852 0-1.536.881-1.536 2.062 0 .751.254 1.26.254 1.26l-1.025 4.34c-.304 1.289-.046 2.867-.024 3.027.013.094.135.117.19.046.078-.103 1.093-1.355 1.438-2.607.097-.354.56-2.19.56-2.19.277.529 1.086.993 1.946.993 2.56 0 4.297-2.334 4.297-5.458 0-2.363-2-4.563-5.042-4.563z"
                />
            </g>
        </svg>
    )
}
